"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var highlightWords_1 = __importDefault(require("./highlightWords"));
/**
 * Mutate a `node` by highlighting and setting its `textContent` property.
 * @private
 */


var mutateNode = function mutateNode(node, words) {
  // We only want to highlight text nodes, so recursively find those nodes.
  if (node.childNodes.length > 0) {
    Array.from(node.childNodes).forEach(function (childNode) {
      return mutateNode(childNode, words);
    });
  }

  if (node.nodeType === 3) {
    // eslint-disable-next-line no-param-reassign
    node.textContent = highlightWords_1.default(node.textContent || '', words);
  }
};
/**
 * Highlight content in a `node`.
 */


var highlightNodeContent = function highlightNodeContent(node, words) {
  var subject = node.cloneNode(true); // Highlight content in the node by mutating it.

  mutateNode(subject, words);
  return subject;
};

exports.default = highlightNodeContent;